import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-3.5,-0.5h0.5v0.5h-0.5zM1.5,-0.5h2v0.5h-2zM-3.5,0h1v0.5h-1zM-1,0h3.5v0.5h-3.5zM-3,0.5h3v0.5h-3zM2,0.5h0.5v1.5h-0.5zM-3,1h1v1h-1zM-2.5,2h0.5v0.5h-0.5z',
    },
    {
      paint: 'dock',
      d: 'M1,-1.5h2v0.5h-2zM-3,-1h1v0.5h-1zM-1.5,-1h5v0.5h-5zM-3,-0.5h4.5v0.5h-4.5zM-2.5,0h1.5v0.5h-1.5z',
    },
    { paint: 'wheat', d: 'M-1,-1.5h2v0.5h-2zM-3.5,-1h0.5v0.5h-0.5zM-2,-1h0.5v0.5h-0.5z' },
  ],
  pixels: 62,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
